import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ParentUsersUIHelpers";

const ParentUsersUIContext = createContext();

export function useParentUsersUIContext() {
  return useContext(ParentUsersUIContext);
}

export const ParentUsersUIConsumer = ParentUsersUIContext.Consumer;

export function ParentUsersUIProvider({ parentUsersUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openIPListEditModal: parentUsersUIEvents.openIPListEditModal
  };

  return (
    <ParentUsersUIContext.Provider value={value}>
      {children}
    </ParentUsersUIContext.Provider>
  );
}